import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LIST_KEYS, LIST_DEFAULTS } from './routes';

// The Review list's state lives in the address (so a reload or a link keeps it). `set` merges a patch; empty values
// and defaults leave the address; any change other than the page itself goes back to page 1.
export default function useQueryState() {
  const [params, setParams] = useSearchParams();
  const state = useMemo(() => Object.fromEntries(LIST_KEYS.map((k) => [k, params.get(k) ?? LIST_DEFAULTS[k] ?? ''])), [params]);
  const set = useCallback((patch) => setParams((prev) => {
    const next = new URLSearchParams(prev);
    Object.entries(patch).forEach(([k, v]) => {
      if (v === '' || v == null || v === LIST_DEFAULTS[k]) next.delete(k); else next.set(k, String(v));
    });
    if (!('page' in patch)) next.delete('page');
    return next;
  }, { replace: true }), [setParams]);
  // The list-only part of the address, for product links to carry back.
  const search = useMemo(() => {
    const out = new URLSearchParams();
    LIST_KEYS.forEach((k) => { const v = params.get(k); if (v) out.set(k, v); });
    return out.toString();
  }, [params]);
  return [state, set, search];
}
